// extracted by mini-css-extract-plugin
var _1 = "t2te";
var _2 = "t2tf";
export { _1 as "header", _2 as "invertedHeader" }
